export interface FileAttachmentFile {
  url?: string | null;
  /** Presigned URL with Content-Disposition: attachment. Preferred for download. */
  downloadUrl?: string | null;
  meta: {
    name?: string | null;
    size?: number | null;
    mimeType?: string | null;
  };
}

export interface FileAttachmentProps {
  file: FileAttachmentFile;
  /** Show remove button */
  clearable?: boolean;
  /** Show uploading state */
  uploading?: boolean;
  /** Show error state — replaces the success/uploading visuals with a red error row */
  error?: boolean;
  /** Optional human-readable error message rendered under the file name */
  errorMessage?: string;
  /**
   * Asked on the download click, before the link opens, for a URL to use
   * instead of `file`'s — a presigned one renewed just now when the one held
   * may have expired. A null answer falls back to `file`'s own.
   */
  resolveDownloadUrl?: () => Promise<string | null | undefined>;
}

/**
 * Get icon name based on MIME type
 */
export function getFileIcon(mimeType?: string | null): string {
  if (!mimeType) {
    return 'i-lucide-file';
  }

  const type = mimeType.toLowerCase();

  if (type.startsWith('image/')) {
    return 'i-lucide-image';
  }

  if (type === 'application/pdf') {
    return 'i-lucide-file-text';
  }

  if (type.includes('word') || type.includes('document')) {
    return 'i-lucide-file-text';
  }

  if (type.includes('excel') || type.includes('spreadsheet') || type === 'text/csv') {
    return 'i-lucide-file-spreadsheet';
  }

  if (type.includes('zip') || type.includes('archive') || type.includes('compressed')) {
    return 'i-lucide-file-archive';
  }

  return 'i-lucide-file';
}
